var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"seal",style:({ backgroundImage: 'url(/images/seal.svg)' })})
}
var staticRenderFns = []

export { render, staticRenderFns }